import { styled } from "@styles";

export const Name = styled.span`
  display: block;
  margin-bottom: 0.625rem;
  font-weight: ${props => props.theme.typography.boldFontWeight};
`;
